<template>
  <div>
    <Company @titleFromChild="onTitleChanged"/>
  </div>
</template>

<script>
import Company from './Company.vue'

export default {
  name: 'home',
  data: function () {
    return {
    }
  },
  components: {
    Company
  },
  created () {

  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onTitleChanged (title) {
      this.$emit('titleFromChild', title)
    }
  }
}
</script>

<style lang="scss">
</style>
